'use client';

import type { ABTestVersion } from '../types';

export const getRandomNumber = (from: number, to: number) =>
  Number((Math.random() * (to - from) + from).toFixed(3));

export const getRandomABTestVersion = (versions: ABTestVersion[]) => {
  const randomNumber = getRandomNumber(1, 100);

  const ascendingProbability = (
    versionA: ABTestVersion,
    versionB: ABTestVersion
  ) => versionA.probability - versionB.probability;

  const transformProbability = (
    version: ABTestVersion,
    index: number,
    versions: ABTestVersion[]
  ) => {
    if (index === 0) return version;

    const probability = versions
      .slice(0, index + 1)
      .reduce((sum, { probability }) => sum + probability, 0);

    return {
      ...version,
      probability: versions.length === index + 1 ? 100 : probability,
    };
  };

  const appropriateByRandomNumber = ({ probability }: ABTestVersion) =>
    probability >= randomNumber;

  return [...versions]
    .sort(ascendingProbability)
    .map(transformProbability)
    .find(appropriateByRandomNumber);
};
